import { default as _91room_939onxOietRoMeta } from "/home/node/pages/[room].vue?macro=true";
import { default as floorplanCTkGae6xynMeta } from "/home/node/pages/[tenant]/floorplan.vue?macro=true";
import { default as meeting_45roomK0Pu8t6xg5Meta } from "/home/node/pages/[tenant]/meeting-room.vue?macro=true";
import { default as floorplan2e6MkkgORcMeta } from "/home/node/pages/floorplan.vue?macro=true";
import { default as indexjBvbyAgHxEMeta } from "/home/node/pages/index.vue?macro=true";
import { default as meeting_45roomwwFXfuc7NwMeta } from "/home/node/pages/meeting-room.vue?macro=true";
import { default as printUhooVrHcCHMeta } from "/home/node/pages/print.vue?macro=true";
import { default as rvs_45registerEMzMsP9uV0Meta } from "/home/node/pages/rvs-register.vue?macro=true";
import { default as uko_45printu8Y6qdLQ2uMeta } from "/home/node/pages/uko-print.vue?macro=true";
export default [
  {
    name: _91room_939onxOietRoMeta?.name ?? "room",
    path: _91room_939onxOietRoMeta?.path ?? "/:room()",
    meta: _91room_939onxOietRoMeta || {},
    alias: _91room_939onxOietRoMeta?.alias || [],
    redirect: _91room_939onxOietRoMeta?.redirect || undefined,
    component: () => import("/home/node/pages/[room].vue").then(m => m.default || m)
  },
  {
    name: floorplanCTkGae6xynMeta?.name ?? "tenant-floorplan",
    path: floorplanCTkGae6xynMeta?.path ?? "/:tenant()/floorplan",
    meta: floorplanCTkGae6xynMeta || {},
    alias: floorplanCTkGae6xynMeta?.alias || [],
    redirect: floorplanCTkGae6xynMeta?.redirect || undefined,
    component: () => import("/home/node/pages/[tenant]/floorplan.vue").then(m => m.default || m)
  },
  {
    name: meeting_45roomK0Pu8t6xg5Meta?.name ?? "tenant-meeting-room",
    path: meeting_45roomK0Pu8t6xg5Meta?.path ?? "/:tenant()/meeting-room",
    meta: meeting_45roomK0Pu8t6xg5Meta || {},
    alias: meeting_45roomK0Pu8t6xg5Meta?.alias || [],
    redirect: meeting_45roomK0Pu8t6xg5Meta?.redirect || undefined,
    component: () => import("/home/node/pages/[tenant]/meeting-room.vue").then(m => m.default || m)
  },
  {
    name: floorplan2e6MkkgORcMeta?.name ?? "floorplan",
    path: floorplan2e6MkkgORcMeta?.path ?? "/floorplan",
    meta: floorplan2e6MkkgORcMeta || {},
    alias: floorplan2e6MkkgORcMeta?.alias || [],
    redirect: floorplan2e6MkkgORcMeta?.redirect || undefined,
    component: () => import("/home/node/pages/floorplan.vue").then(m => m.default || m)
  },
  {
    name: indexjBvbyAgHxEMeta?.name ?? "index",
    path: indexjBvbyAgHxEMeta?.path ?? "/",
    meta: indexjBvbyAgHxEMeta || {},
    alias: indexjBvbyAgHxEMeta?.alias || [],
    redirect: indexjBvbyAgHxEMeta?.redirect || undefined,
    component: () => import("/home/node/pages/index.vue").then(m => m.default || m)
  },
  {
    name: meeting_45roomwwFXfuc7NwMeta?.name ?? "meeting-room",
    path: meeting_45roomwwFXfuc7NwMeta?.path ?? "/meeting-room",
    meta: meeting_45roomwwFXfuc7NwMeta || {},
    alias: meeting_45roomwwFXfuc7NwMeta?.alias || [],
    redirect: meeting_45roomwwFXfuc7NwMeta?.redirect || undefined,
    component: () => import("/home/node/pages/meeting-room.vue").then(m => m.default || m)
  },
  {
    name: printUhooVrHcCHMeta?.name ?? "print",
    path: printUhooVrHcCHMeta?.path ?? "/print",
    meta: printUhooVrHcCHMeta || {},
    alias: printUhooVrHcCHMeta?.alias || [],
    redirect: printUhooVrHcCHMeta?.redirect || undefined,
    component: () => import("/home/node/pages/print.vue").then(m => m.default || m)
  },
  {
    name: rvs_45registerEMzMsP9uV0Meta?.name ?? "rvs-register",
    path: rvs_45registerEMzMsP9uV0Meta?.path ?? "/rvs-register",
    meta: rvs_45registerEMzMsP9uV0Meta || {},
    alias: rvs_45registerEMzMsP9uV0Meta?.alias || [],
    redirect: rvs_45registerEMzMsP9uV0Meta?.redirect || undefined,
    component: () => import("/home/node/pages/rvs-register.vue").then(m => m.default || m)
  },
  {
    name: uko_45printu8Y6qdLQ2uMeta?.name ?? "uko-print",
    path: uko_45printu8Y6qdLQ2uMeta?.path ?? "/uko-print",
    meta: uko_45printu8Y6qdLQ2uMeta || {},
    alias: uko_45printu8Y6qdLQ2uMeta?.alias || [],
    redirect: uko_45printu8Y6qdLQ2uMeta?.redirect || undefined,
    component: () => import("/home/node/pages/uko-print.vue").then(m => m.default || m)
  }
]